import Api from '@/services/Api'

// used to run api calls related to redemption codes and join codes

export default {
  get(code) {
    return Api().get(`codes/${code}`);
  },
  redeemSourceCode(code) {
    return Api().post('codes/redeemSourceCode', {code: code});
  },
  redeemRedemptionCode(code) {
    return Api().post('codes/redeemRedemptionCode', {code: code});
  },
  processJoinCodeForUser(code) {
    return Api().post('processJoinCode', {joinCode: code});
  },
  processJoinCodeForSignup(payload) {
    return Api().post('registerWithJoinCode', payload);
  },
  registerWithSourceCode(code, payload) {
    return Api().post('registerWithSourceCode', {
      sourceCode: { code: code },
      user: payload
    })
  },
  registerWithRedemptionCode(code, payload) {
    return Api().post('registerWithRedemptionCode', {
      redemptionCode: { code: code },
      user: payload
    })
  }
}